// features/licenses/licenseSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchUsers = createAsyncThunk(
  'Users/fetchUsers',
  async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/user`, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
        },
      });
      console.log('Users fetched:', res.data);
      return res.data.filter((user) => !user.deleted);
    } catch (error) {
      console.error('Error fetching users:', error);
      // This will make the thunk rejected and pass the error to the reducer
      throw error;
    }
  }
);


const UserSlice = createSlice({
  name: 'Users',
  initialState: {
      users: {
        data: [],
        loading: false,
        error: null,
      },
    },
  reducers: {},
   extraReducers: (builder) => {
    // FETCH LICENSES
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.users.loading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.users.loading = false;
        state.users.data = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.users.loading = false;
        state.users.error = action.error.message;
      });
  },
});

export default UserSlice.reducer;
